// extracted by mini-css-extract-plugin
export default {"resetButton":"JYipCol","body":"nCrjcZe","isDragging":"_6A5Jut7","closeBtn":"UkwOcOI"};